// <s-sticky-buy> (snippets/sticky-buy-bar.liquid): bottom buy bar.
// Visible (data-visible, not inert) as soon as the page's add-to-cart button
// (size grid [data-size-add] or the form's button[name="add"]) has scrolled up
// out of view, hidden again while the page footer is on screen.
// [data-sticky-buy] scrolls back to the buy box.
const BUTTON_SELECTOR = '[data-size-add], button[name="add"]';

class SStickyBuy extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    this.addEventListener('click', (event) => {
      if (!event.target.closest('[data-sticky-buy]')) return;
      const box = this.#box();
      box?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const first = box?.querySelector('input[data-size-qty]:not(:disabled), button[name="add"]');
      window.setTimeout(() => first?.focus({ preventScroll: true }), 600);
    }, { signal });

    const schedule = () => {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    };
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    // Capture also catches pages that scroll inside an element (body or a
    // preview wrapper) instead of the window.
    document.addEventListener('scroll', schedule, { passive: true, capture: true, signal });
    document.addEventListener('touchmove', schedule, { passive: true, signal });
    // Safety net for environments that don't emit scroll events to the page.
    const timer = window.setInterval(schedule, 400);
    signal.addEventListener('abort', () => window.clearInterval(timer));
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }

  #box() {
    return document.querySelector(this.dataset.target || 's-product-form');
  }

  #update() {
    // Re-query each time: partial rendering can replace the button.
    const button = this.#box()?.querySelector(BUTTON_SELECTOR) || this.#box();
    const footer = document.querySelector('footer');
    const viewport = window.innerHeight || document.documentElement.clientHeight;

    const buttonGone = button ? button.getBoundingClientRect().bottom < 0 : false;
    const footerShown = footer ? footer.getBoundingClientRect().top < viewport : false;
    const visible = buttonGone && !footerShown;

    if (visible === this.hasAttribute('data-visible')) return;
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
